import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Field Card Expiry Year'
export const group = ''

export default class ElFieldCardExpYear extends SectionProvider {
  constructor (options = {}) {
    super('ElFieldCardExpYear', options)

    this.name = name
    this.group = group
  }
}